import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { useQuery, useLazyQuery, useApolloClient, gql } from '@apollo/client';
import { historyShape } from 'constants/propTypes';
import { GET_JOURNEYS, CHEAPEST_FARES_SEARCH } from 'store/queries';
import { withStations } from 'components/queries/GetStationsQuery';
import { withBooking } from 'components/queries/GetBookingQuery';
import { withUser } from 'components/queries/GetUserQuery';
import JourneySearch from './JourneySearch';
import { getSearchParams } from './JourneySearch.utils';

import { buildCheapestFaresSearchRequest, validProductFamiliesForCheapestFaresSearch } from './CheapestFaresSearch.utils';

const Index = (props) => {
  const {
    history: {
      location: { search }
    }
  } = props;

  const client = useApolloClient();
  const searchParams = getSearchParams(search);
  const membershipNumber = new URLSearchParams(search).get('membershipNumber');
  const cheapestFaresSearchRequest = buildCheapestFaresSearchRequest({
    ...searchParams
  });
  const areProductFamiliesValidForCheapestFaresSearch = validProductFamiliesForCheapestFaresSearch(searchParams);

  const [cheapestFaresRequest, { loading: cheapestFareLoading, data: cheapestFares }] = useLazyQuery(CHEAPEST_FARES_SEARCH, {
    variables: cheapestFaresSearchRequest
  });

  useEffect(() => {
    if (areProductFamiliesValidForCheapestFaresSearch) {
      cheapestFaresRequest();
    }
  }, [search, areProductFamiliesValidForCheapestFaresSearch, cheapestFaresRequest]);

  const getJourneysVariables = { ...searchParams, useNewLoyaltySystem: true };
  const { loading, error, data } = useQuery(GET_JOURNEYS, {
    variables: getJourneysVariables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onError: () => {
      client.writeQuery({
        query: gql`
          query {
            searchParams @client {
              outboundDate
              inboundDate
              origin
              destination
              adults
              children
              infants
              youths
              seniors
              currency
              productFamilies
            }
          }
        `,
        data: {
          searchParams: {
            ...searchParams,
            __typename: 'SearchParams'
          }
        }
      });
    }
  });

  return (
    <JourneySearch
      {...props}
      loading={loading || cheapestFareLoading}
      error={error}
      data={data}
      searchParams={searchParams}
      membershipNumber={membershipNumber}
      cheapestFares={cheapestFares?.cheapestFaresSearch}
    />
  );
};

Index.propTypes = {
  history: historyShape,
  client: PropTypes.shape({
    cache: PropTypes.shape({
      writeQuery: PropTypes.func
    })
  })
};

export default withStations(withBooking(withUser(withRouter(Index))));
